import BaseApi from "./_base-api";

/**
 * Calendar API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {}

const api = new Api({
	type: "Calendar",
	path: "calendars"
});

export default api;
